import { useEffect, useState } from "react"



export default function ErrorTest() {
  const [triggerError, setTriggerError] = useState(false);

  useEffect(() => {
    if (triggerError) {
      // Intentionally throw an error
      throw new Error('This is a test error');
    }
  }, [triggerError]);

  const handleClick = () => {
    setTriggerError(true);
  };

  return (
    <div style={{margin: '20px'}}>
      <h1>Error Test Component</h1>
      <button onClick={handleClick}>Trigger Error</button>
    </div>
  );
}
